import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const workHours = useStore((state) => state.workHours);
  const setWorkHours = useStore((state) => state.setWorkHours);
  const { onNext, onPrev, currentIndex } = useNav();


  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.workHours.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={workHours}
          onChange={(value) => {
            setWorkHours(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'work-hours',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"I have a flexible schedule"}>
            <span>🕊️</span> {t('onboarding.workHours.options.flexible')}
          </Option>
          <Option value={"I work 9 to 6"}>
            <span>🕘</span> {t('onboarding.workHours.options.nineToSix')}
          </Option>
          <Option value={"I work shifts"}>
            <span>🔁</span> {t('onboarding.workHours.options.shifts')}
          </Option>
          <Option value={"I have seasonal work"}>
            <span>☀️</span> {t('onboarding.workHours.options.seasonal')}
          </Option>
          <Option value={"Other"}>
            <span>✨</span> {t('onboarding.workHours.options.other')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
